module.exports = __webpack_public_path__ + "img/Banner1_E.b04d16ab.jpg";